export const selectRandomOption = (options: string[]): number => {
  const validOptions = options.filter(o => o.trim().length > 0);
  if (validOptions.length === 0) {
    throw new Error('No valid options provided');
  }
  return Math.floor(Math.random() * validOptions.length);
};
